import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { Equipments, Drivers } from './equipmentsModels';
import { type APIResponse } from '@store/Shared/shared';

export const GetEquipmentsList = createAsyncThunk('Equipments/GetEquipmentsList', async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const { data } = await ntxAPI.get<APIResponse<any>>('Fleet/GetEquipmentsList');
    // debugger;
    if (data.succeeded === true) {
      return data.data;
    } else {
      return rejectWithValue(data.message);
    }
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const GetEquipmentsById = createAsyncThunk('Equipments/GetEquipmentsById', async (id: string, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const { data } = await ntxAPI.get(`Fleet/GetEquipmentsById?Id=${id}`);
    return data.data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const InsertEquipments = createAsyncThunk(
  'Equipments/InsertEquipments',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Fleet/AddEquipments', item, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      if (data?.succeeded) {
        return data;
      } else {
        return rejectWithValue(data?.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateEquipments = createAsyncThunk(
  'Equipments/UpdateEquipments',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Fleet/UpdatEquipments', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getMyEquipmentsList = createAsyncThunk('Equipments/getMyEquipmentsList', async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const { data } = await ntxAPI.get('Fleet/GetMyEquipmentsList');

    return data.data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const GetDriversList = createAsyncThunk('Equipments/GetDriversList', async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const { data } = await ntxAPI.get('Fleet/GetDriversList');

    return data.data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

export const getEquipmentsCountDP = createAsyncThunk('Equipments/getEquipmentsCountDP', async (_, thunkAPI) => {
  const { rejectWithValue } = thunkAPI;
  try {
    const { data } = await ntxAPI.get('Fleet/GetEquipmentsCountDP');

    return data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

interface EquipmentState {
  EquipmentsList: Equipments[];
  loading: boolean;
  error: any | null;
  //
  EquipmentsById?: Equipments;
  loadingById: boolean;
  errorById: any | null;
  //
  MyEquipmentsList: Equipments[];
  //
  DriversList: Drivers[]; // يمكن استبدال any بنوع السائق Driver إذا كان متوفرًا
  loadingDrivers: boolean;
  errorDrivers: any | null;
}

const initialState: EquipmentState = {
  EquipmentsList: [],
  loading: false,
  error: null,
  //
  EquipmentsById: {} as Equipments,
  loadingById: false,
  errorById: null,
  //
  MyEquipmentsList: [],
  //
  DriversList: [] as Drivers[],
  loadingDrivers: false,
  errorDrivers: null
};

const equipmentsSlice = createSlice({
  name: 'Equipments',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(InsertEquipments.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(InsertEquipments.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.EquipmentsList?.push(action.payload?.data);
      })
      .addCase(InsertEquipments.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(GetEquipmentsList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(GetEquipmentsList.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.EquipmentsList = action.payload;
      })
      .addCase(GetEquipmentsList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //~~~~~~~~~~~~
      .addCase(GetEquipmentsById.pending, (state, action) => {
        state.loadingById = true;
        state.errorById = null;
      })
      .addCase(GetEquipmentsById.fulfilled, (state, action: PayloadAction<Equipments>) => {
        state.loadingById = false;
        state.EquipmentsById = action.payload;
      })
      .addCase(GetEquipmentsById.rejected, (state, action: PayloadAction<any>) => {
        state.loadingById = false;
        state.errorById = action.payload;
      })
      //~~~~~~~~~~~~
      .addCase(getMyEquipmentsList.pending, (state, action) => {
        state.loadingById = true;
        state.errorById = null;
      })
      .addCase(getMyEquipmentsList.fulfilled, (state, action: PayloadAction<Equipments[]>) => {
        state.loadingById = false;
        state.MyEquipmentsList = action.payload;
      })
      .addCase(getMyEquipmentsList.rejected, (state, action: PayloadAction<any>) => {
        state.loadingById = false;
        state.errorById = action.payload;
      })

      //~~~~~~~~~~~~
      .addCase(GetDriversList.pending, (state, action) => {
        state.loadingDrivers = true;
      })
      .addCase(GetDriversList.fulfilled, (state, action: PayloadAction<Drivers[]>) => {
        state.loadingDrivers = false;
        state.DriversList = action.payload;
      })
      .addCase(GetDriversList.rejected, (state, action: PayloadAction<any>) => {
        state.loadingDrivers = false;
        state.errorDrivers = action.payload;
      });
    //~~~~~~~~~~~~
  }
});

export default equipmentsSlice.reducer;
